import React, { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import api from "../supabase/axios";

function Hero() {
  const navigate = useNavigate();
  const contentRef = useRef(null);
  const inView = useInView(contentRef, { once: true, margin: "-100px" });

  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 300], [0, -50]);

  const [canAutoplay, setCanAutoplay] = useState(true);
  const [banner, setBanner] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch banner data
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await api.get("/api/banners");
        const banners = response.data;
        if (banners && banners.length > 0) {
          setBanner(banners[0]); // Use the first banner
        }
        setIsLoading(false);
      } catch (err) {
        setError("Failed to load banner");
        setIsLoading(false);
      }
    };
    fetchBanner();
  }, []);

  // Test video autoplay capability
  useEffect(() => {
    const testVideo = document.createElement("video");
    testVideo.muted = true;
    testVideo.playsInline = true;
    testVideo
      .play()
      .then(() => setCanAutoplay(true))
      .catch(() => setCanAutoplay(false));
  }, []);

  // Transform title to include styled spans
//   const formatTitle = (title) => {
//   if (!title) {
//     // ✅ Was: return '' (unreachable fallback below it)
//     return 'Timeless <span class="text-pink-400">Elegance</span><br /><span class="text-green-300">Redefined</span>';
//   }
//   const parts = title.split(" ");
//   if (parts.length >= 3 && parts[1] === "Elegance" && parts[2] === "Redefined") {
//     return `Timeless <span class="text-pink-400">Elegance</span><br /><span class="text-green-300">Redefined</span>`;
//   }
//   return title;
// };
  const formatTitle = (title) => {
  if (!title) {
    // ✅ Was: return '' (unreachable fallback below it)
    return '  <span class="text-pink-400">  </span><br /><span class="text-green-300"> </span>';
  }
  const parts = title.split(" ");
  if (parts.length >= 3 && parts[1] === "Elegance" && parts[2] === "Redefined") {
    return `Timeless <span class="text-pink-400">Elegance</span><br /><span class="text-green-300">Redefined</span>`;
  }
  return title;
};

  // Fallback content
  const title = formatTitle(banner?.Title);
  const description = banner?.Description;
  const mediaUrl = banner?.ImageUrl;

  return (
    <section className="relative min-h-screen w-screen left-1/2 -translate-x-1/2 overflow-hidden bg-[#F1E7E5]">
      {/* Parallax Video Background */}
      <motion.div
        style={{ y }}
        className="absolute top-0 left-0 w-full h-full z-0"
      >
        {isLoading ? (
          <div className="w-full h-full bg-gradient-to-r from-[#8d6e63] to-[#bcaaa4]" />
        ) : mediaUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
          <video
            autoPlay={canAutoplay}
            loop
            muted
            playsInline
            aria-hidden="true"
            className="w-full h-full object-cover sm:object-center"
          >
            <source src={mediaUrl} type="video/mp4" />
          </video>
        ) : (
          <img
            src={mediaUrl}
            alt="Banner"
            className="
w-full
h-full
object-cover
object-[82%_center]
md:object-center
"
          />
        )}
      </motion.div>

      {/* Overlay */}
      {/* <div className="absolute top-0 left-0 w-full h-auto bg-black/40 z-10" /> */}
      <div className="
  mt-8
  flex
  flex-col
  sm:flex-row
  flex-wrap
  items-center
  gap-4
  justify-center
  md:justify-start
"></div>
      {/* Text Content */}
      <div className="relative z-20 flex items-center justify-center min-h-screen px-4 sm:px-6 py-8 sm:py-12">
        <motion.div
          ref={contentRef}
          className="w-full max-w-3xl text-white text-center md:text-left"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold leading-snug"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p className="mt-5 max-w-xl text-base sm:text-lg text-gray-100 leading-relaxed">
            {description}
          </p>

          {/* Premium CTA Area */}
          {/* <div className="mt-10 flex flex-wrap items-center gap-5 justify-center md:justify-start"> */}
          <div className="
absolute
z-30

left-[50%]
top-[85%]
-translate-x-1/2
-translate-y-1/2

flex
flex-col
sm:flex-row
flex-wrap
items-center
gap-4
justify-center
">

            {/* Main CTA */}
            <button
              onClick={() => navigate("/products")}
              className="
      group
      relative
      overflow-hidden
      rounded-full
      px-9 py-4
      bg-white/95
      text-black
      font-semibold
      tracking-wide
      shadow-[0_15px_40px_rgba(0,0,0,0.25)]
      backdrop-blur-xl
      transition-all duration-500
      hover:scale-105
      hover:shadow-[0_25px_55px_rgba(255,255,255,0.20)]
    "
            >
              <span className="relative z-10 flex items-center gap-2">
                Shop Collection
                <span className="transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </span>

              <div className="
      absolute inset-0
      bg-gradient-to-r
      from-[#d4af37]
      via-[#f5e7b2]
      to-[#d4af37]
      opacity-0
      transition-opacity duration-500
      group-hover:opacity-100
    "/>
            </button>

            {/* Secondary CTA */}
            <button
              onClick={() => navigate("/about")}
              className="
      rounded-full
      px-9 py-4
      border border-white/30
      bg-white/10
      backdrop-blur-2xl
      text-white
      font-medium
      tracking-wide
      transition-all duration-500
      hover:bg-white
      hover:text-black
      hover:border-white
      hover:scale-105
    "
            >
              Learn Our Story
            </button>

          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;